let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5a3mm")).then(() => parcelRequire('4jimO'));